import AliasAddModal from "./AliasAddModal";

export default AliasAddModal;